import { render } from "./CreateNewElementGroup.vue?vue&type=template&id=60b93795"
import script from "./CreateNewElementGroup.vue?vue&type=script&lang=js"
export * from "./CreateNewElementGroup.vue?vue&type=script&lang=js"

import "./CreateNewElementGroup.vue?vue&type=style&index=0&id=60b93795&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__